// extracted by mini-css-extract-plugin
export default {"day_of_week_table":"style_day_of_week_table__7V4bK","day_td":"style_day_td__EICO2","td_box":"style_td_box__w22b6","active":"style_active__-7SXc"};